var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.3739H24.75C24.75 6.60262 20.3929 2.25 14.6138 2.25V4.5C19.1835 4.5 22.5 7.81087 22.5 12.3739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6248 8.99954C16.9907 8.99954 17.9998 10.0087 17.9998 12.3745H20.2498C20.2498 8.74641 18.253 6.74954 14.6248 6.74954V8.99954ZM18.4746 15.1229C18.2584 14.9264 17.9743 14.8216 17.6824 14.8307C17.3904 14.8397 17.1133 14.9618 16.9097 15.1713L14.2176 17.9399C13.5696 17.8162 12.2668 17.41 10.9258 16.0724C9.58483 14.7303 9.1787 13.4242 9.05833 12.7807L11.8247 10.0874C12.0344 9.88393 12.1567 9.60684 12.1658 9.31477C12.1748 9.0227 12.0698 8.73858 11.8731 8.52254L7.7162 3.95166C7.51938 3.73494 7.24582 3.60348 6.95363 3.5852C6.66143 3.56693 6.37363 3.66328 6.15133 3.85379L3.71008 5.94741C3.51558 6.14262 3.39949 6.40242 3.38383 6.67754C3.36695 6.95879 3.0452 13.621 8.2112 18.7893C12.718 23.2949 18.3632 23.6245 19.918 23.6245C20.1452 23.6245 20.2847 23.6178 20.3218 23.6155C20.5969 23.6001 20.8566 23.4835 21.0508 23.2882L23.1433 20.8458C23.334 20.6236 23.4305 20.3359 23.4125 20.0437C23.3944 19.7515 23.2631 19.4779 23.0466 19.2809L18.4746 15.1229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.47ada0a7e326a6be5be70725a4281e96.svg";
export { ForwardRef as ReactComponent };